/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react'

import StrikeZoneDumb from './StrikeZones/Dumb.tsx'

import getStrikeZoneDims from './StrikeZones/get-strike-zone-dims.ts'
import {
    useChartOptions,
    useLocationAccurate_TODOFIX,
    useScales,
    useStrikeZoneType,
} from '../../Context/ChartContext.tsx'
import StrikeZoneFuzzyBackground from './StrikeZones/FuzzyBackground.tsx'

const strikeZoneBackground = '#f2f2f2'

function StrikeZone() {
    const { settings } = useChartOptions()
    const { xScale, yScale } = useScales()
    const strikeZone = useStrikeZoneType()

    const strikeZoneDims = getStrikeZoneDims(strikeZone, settings.data)

    const isLocationAccurate = useLocationAccurate_TODOFIX()

    if (isLocationAccurate) {
        return <StrikeZoneFuzzyBackground bgColor={strikeZoneBackground} />
    }

    switch (strikeZone) {
        // case 'generic-old':
        case 'personal':
        case 'average':
        case 'generic':
            return (
                <StrikeZoneDumb
                    xScale={xScale}
                    yScale={yScale}
                    szTop={strikeZoneDims.top}
                    szBot={strikeZoneDims.bot}
                    plateWidthFt={strikeZoneDims.width}
                    // Todo: Send specific stroke color?
                    styles={{
                        strokeDasharray: 'none',
                        fill: strikeZoneBackground,
                        fillOpacity: 1,
                        stroke: strikeZoneBackground,
                        strokeOpacity: 1,
                    }}
                />
            )
        // case 'fuzzy':
        //     return (
        //         <StrikeZoneFuzzy
        //             xScale={xScale}
        //             yScale={yScale}
        //             data={settings.data}
        //         />
        //     )
        default:
            return null
    }
}

export default function StrikeZoneBackground() {
    return (
        <g>
            <StrikeZone />
        </g>
    )
}
